import * as React from "react";
const SvgFileUploadIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 16.5H15V10.5H19L12 3.5L5 10.5H9V16.5ZM5 18.5H19V20.5H5V18.5Z" }));
export default SvgFileUploadIcon;
